module.exports = __webpack_public_path__ + "static/5-6879f2d1b54fbcde06c9f12c7f00c22d.svg";